// Озвучка через голоса браузера (Web Speech API). Голос по умолчанию запоминается отдельно для каждого языка.

export const VOICE_KEYS = { it: 'defaultItalianVoice', ru: 'defaultRussianVoice' };
export const SPEECH_LANG = { it: 'it-IT', ru: 'ru-RU' };

export function voicesFor(voices, target) {
  return (voices || []).filter((v) => (v.lang || '').toLowerCase().startsWith(target));
}

export function savedVoiceName(target) {
  try {
    return localStorage.getItem(VOICE_KEYS[target]);
  } catch (e) {
    return null;
  }
}

export function saveVoiceName(target, name) {
  try {
    localStorage.setItem(VOICE_KEYS[target], name);
  } catch (e) {
    // localStorage недоступен — выбор просто не запомнится
  }
}

export function pickVoice(voices, target) {
  const candidates = voicesFor(voices, target);
  const saved = savedVoiceName(target);
  return candidates.find((v) => v.name === saved) || candidates[0] || null;
}

// Текст для синтезатора: без знаков ударения и без транслитерации после « — »
export function speakableText(text) {
  return (text || '').split(' — ')[0].replace(/́/g, '');
}

export function speak(voices, text, target = 'it', { rate = 1, pitch = 1 } = {}) {
  if (!text || !window.speechSynthesis) return false;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(speakableText(text));
  u.lang = SPEECH_LANG[target] || target;
  u.rate = rate;
  u.pitch = pitch;
  const voice = pickVoice(voices, target);
  if (voice) u.voice = voice;
  window.speechSynthesis.speak(u);
  return Boolean(voice);
}
